import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';

import { columns, formatDataTable, getAllAlertNotifications } from './alert_notification_logic';
import OneColumn from '../layout/containers/OneColumn';
import { Card, Col, Container, Row } from 'react-bootstrap';

const AlertNotificationTable = (props) => {
  const [alertDataList, setAlertDataList] = useState([]);
  const [updateReadCheck, setUpdateReadCheck] = useState(false);

  let pageConfig = {
    active: 'notifications',
    title: 'Notifications',
  };

  useEffect(() => {
    (async function () {
      const response = await getAllAlertNotifications();
      const listDataFormatAlert = await formatDataTable(
        response,
        setUpdateReadCheck,
        updateReadCheck
      );
      setAlertDataList(listDataFormatAlert);
    })();
  }, [updateReadCheck]);

  return (
    <OneColumn {...props} pageConfig={pageConfig} hideTopMenu={true} fluid noTitle>
      <Container
        fluid={true}
        className="bg-size-cover"
        style={{
          minHeight: '100vh',
          backgroundImage: 'url(' + process.env.PUBLIC_URL + '/img/login_wallpaper.png)',
        }}
      >
        <Container>
          <Row style={{ minHeight: '100vh' }}>
            <Col sm={12} md={{ span: 10, offset: 1 }} className="login-container">
              <Card className="mY-40">
                <Card.Body>
                  <h4>Buzón de notificaciones</h4>

                  <ToolkitProvider keyField="id" data={alertDataList} columns={columns} search>
                    {(props) => (
                      <Row center="xs">
                        <Col xs={12}>
                          <div className={'table-wrapper'}>
                            <BootstrapTable
                              {...props.baseProps}
                              striped
                              hover
                              condensed
                              responsive
                              pagination={paginationFactory()}
                            />
                          </div>
                        </Col>
                        <Col xs={2} />
                      </Row>
                    )}
                  </ToolkitProvider>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
    </OneColumn>
  );
};

export default AlertNotificationTable;
